import React, { useEffect, useRef, useState } from "react";
import { Editor as TinyEditor } from "@tinymce/tinymce-react";
import { useApi, configApiRef } from "@backstage/core-plugin-api";
import { useThemeSettings } from "@internal/plugin-utilities";
import { Progress } from "@backstage/core-components";

interface Props {
  refs: React.MutableRefObject<any>[];
  setRefs: React.Dispatch<React.SetStateAction<React.MutableRefObject<any>[]>>;
  initialValue: string;
}

export const Editor: React.FC<Props> = ({
  refs,
  setRefs,
  initialValue,
}): JSX.Element => {
  const plugins = [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    "anchor",
    "searchreplace",
    "visualblocks",
    "code",
    "fullscreen",
    "insertdatetime",
    "media",
    "table",
    "code",
    "help",
    "wordcount",
  ];

  const toolbar =
    "undo redo | blocks | anchor " +
    "bold italic forecolor | alignleft aligncenter " +
    "alignright alignjustify | bullist numlist outdent indent | " +
    "removeformat | help";

  const config = useApi(configApiRef);
  const theme = useThemeSettings();
  const skin = theme === "dark" ? "oxide-dark" : "material-classic";
  const contentCss = theme === "dark" ? "dark" : "light";
  const apiKey = config.getString("tinymce.token");
  const editorRef = useRef<any>(null);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const newRefs = refs;
    const idx = newRefs.length === 0 ? 0 : newRefs.length;
    newRefs[idx] = editorRef;
    setRefs(newRefs);
  }, [editorRef, refs, setRefs]);

  return (
    <>
      {loading && <Progress />}
      <TinyEditor
        ref={editorRef}
        apiKey={apiKey}
        onInit={(_evt, editor) => {
          editorRef.current = editor;
        }}
        initialValue={initialValue}
        onLoadContent={() => {
          setLoading(false);
        }}
        init={{
          skin,
          content_css: contentCss,
          height: 500,
          menubar: true,
          plugins,
          toolbar,
        }}
      />
    </>
  );
};
